import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';

import { Button, IconButton, Paper, Typography } from '@material-ui/core';

import * as organizationSelectors from '../../selectors/organizationSelectors';
import Avatar from '../Avatar';
import SearchAndPickBucket from '../search/SearchAndPickBucket';
import { BATCH_ACTION_TYPES } from '../../enums/AssetBatchActionTypes';

class BatchMoveToModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOrganization: undefined,
            pickedBucket: undefined,
        };
    }

    onSelectOrganization = selectedOrganization => {
        this.setState({ selectedOrganization });
    };

    onCloseModal = () => {
        this.setState({
            selectedOrganization: undefined,
            pickedBucket: undefined,
        });

        this.props.onClose();
    };

    onMoveAssets = () => {
        const { selectedAssets, executeBatchAction } = this.props;

        this.setState({ selectedOrganization: undefined });

        executeBatchAction(BATCH_ACTION_TYPES.MOVE_TO, selectedAssets, { toBucket: this.state.pickedBucket });
    };

    render() {
        const {
            show,
            isAdmin,
            organizations,
            classes,
            selectedAssets,
        } = this.props;
        
        const { selectedOrganization, pickedBucket } = this.state;

        if (!show) {
            return null;
        }

        const selectedItemsCount = selectedAssets.length;

        const selectionOptions = organizations.map(organization => {
            return (
                <button
                    key={organization.id}
                    className={classes.organization}
                    onClick={() => this.onSelectOrganization(organization)}
                >
                    <Avatar
                        aria-hidden="true"
                        alt={organization.name}
                        src={organization.pictureSmallURL}
                        className={classes.avatar}
                    />
                    {organization.name}
                </button>
            );
        });

        return (
            <div className={classes.container}>
                <Paper className={classes.modal}>
                    <div className={classes.header}>
                        <Typography className={classes.title} variant="title">
                            Move to ({selectedItemsCount} items selected)
                        </Typography>
                        <IconButton
                            aria-label="Close modal"
                            onClick={this.onCloseModal}
                        >
                            x
                        </IconButton>
                    </div>

                    {selectedOrganization === undefined && (
                        <div className={classes.options}>
                            <Typography
                                className={classes.subtitle}
                                variant="subheading"
                            >
                                Choose organization
                            </Typography>
                            {selectionOptions}
                        </div>
                    )}

                    {selectedOrganization && (
                        <div className={classes.options}>
                            <div className={classes.backButtonContainer}>
                                <Button
                                    onClick={() => this.setState({ selectedOrganization: undefined })}
                                    color="default"
                                    className={classes.backButton}
                                >
                                    ← Back to organizations
                                </Button>
                            </div>
                            <SearchAndPickBucket
                                onlyAdminBuckets={!isAdmin}
                                organization={selectedOrganization}
                                onChange={pickedBucket =>
                                    this.setState({ pickedBucket })
                                }
                            />
                        </div>
                    )}

                    <div className={classes.footer}>
                        <Button
                            onClick={this.onMoveAssets}
                            disabled={!pickedBucket}
                            variant="contained"
                            color="primary"
                        >
                            Move
                        </Button>
                    </div>
                </Paper>
                <div
                    className={classes.background}
                    onClick={this.onCloseModal}
                />
            </div>
        );
    }
}

BatchMoveToModal.propTypes = {
    show: PropTypes.bool,
    isAdmin: PropTypes.bool,
    selectedAssets: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    executeBatchAction: PropTypes.func.isRequired,
};

BatchMoveToModal.defaultProps = {
    show: false,
};

const style = ({ palette, typography }) => ({
    container: {
        width: 0,
        height: 0,
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '20px',
        borderBottom: `1px solid ${palette.background.gray2Color}`,
    },
    title: {
        lineHeight: '1.8em',
    },
    subtitle: {
        marginBottom: '16px',
    },
    footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '15px',
        borderTop: `1px solid ${palette.background.gray2Color}`,
    },
    avatar: {
        marginRight: '10px',
    },
    options: {
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
        '& button': {
            outline: 'none',
            border: 'none',
            height: '48px',
            lineHeight: '44px',
            textAlign: 'start',
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            font: 'inherit',
            fontSize: typography.caption.fontSize,
            cursor: 'pointer',
            paddingLeft: '15px',
            '&:hover': {
                backgroundColor: palette.background.gray1Color,
            },
        },
    },
    organization: {
        paddingBottom: '20px',
    },
    background: {
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        background: 'rgba(0, 0, 0, 0.5)',
    },
    modal: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: '50%',
        maxWidth: '550px',
        minWidth: '300px',
        transform: 'translate(-50%, -50%)',
        zIndex: 128,
    },
    backButtonContainer: {
        marginBottom: '16px',
    },
    backButton: {
        padding: '4px 0',
        minWidth: 'auto',
        textTransform: 'none',
    }
});

const mapStateToProps = state => {
    return {
        organizations: organizationSelectors.getOrganizations(state),
    };
};

export default connect(mapStateToProps)(injectSheet(style)(BatchMoveToModal)); 


// WEBPACK FOOTER //
// ./src/components/modals/BatchMoveToModal.js